
$(document).ready(function(){

const acc = document.getElementsByClassName("accordion");
let item;


for (item = 0; item < acc.length; item++){ 

        acc[item].addEventListener("click", function () {
          console.log("clicked!");

            this.classList.toggle("active");
         

            let panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else { 
                panel.style.maxHeight= panel.scrollHeight + "px";
            }

        });
}




   
});

